import { render, staticRenderFns } from "./XeroRedirect.vue?vue&type=template&id=586e0256&scoped=true"
import script from "./XeroRedirect.vue?vue&type=script&lang=js"
export * from "./XeroRedirect.vue?vue&type=script&lang=js"
import style0 from "./XeroRedirect.vue?vue&type=style&index=0&id=586e0256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e0256",
  null
  
)

export default component.exports